export enum AnimationsEnum {
  CUT = 'CUT',
  FADE_IN = 'FADE_IN',
  FADE_OUT = 'FADE_OUT',
}
